module.exports = __webpack_public_path__ + "static/media/12step.1e4a0e5e.svg";